import { usePost } from '@selfserve/react-hooks';
import { apiEndpoints } from '@selfserve/react-utils';

export interface LoginForUpgradeRequest {
  productFamily: string;
  ks: string;
}

export const useLoginForUpgrade = () =>
  usePost<LoginForUpgradeRequest, any>(apiEndpoints.loginForUpgrade);
